import { environment } from 'src/environments/environment'

export const authConfig = {
  issuer: environment.oauthAuthorize,
  redirectUri: environment.baseUrlRedirect,
  clientId: environment.clientId,
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: false,
  requireHttps: environment.production ? true : false,
  oidc: true,
  useSilentRefresh: false,
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh',
  requestAccessToken: true,
  skipIssuerCheck: false,
  disableAtHashCheck: true,
  postLogoutRedirectUri: window.location.origin,
}
